var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_7533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 22.8868H8.79989C8.35828 22.8868 7.99988 22.5284 7.99988 22.0868C7.99988 21.6452 8.35828 21.2868 8.79989 21.2868H23.2C23.6416 21.2868 24 21.6452 24 22.0868C24 22.5284 23.6416 22.8868 23.2 22.8868Z",
    fill: "#95A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.799787 22.8868C0.589629 22.8868 0.385916 22.8048 0.234352 22.6523C0.0380604 22.456 -0.0418233 22.1733 0.021068 21.9034L1.18378 16.97C1.21796 16.825 1.29139 16.6926 1.39706 16.5881L16.1054 1.87977C17.0101 0.974095 18.5929 0.971946 19.4996 1.87977L21.008 3.38799C21.4613 3.84131 21.711 4.44405 21.711 5.08508C21.711 5.72629 21.4613 6.33001 21.008 6.78216L6.29946 21.4895C6.19399 21.5952 6.06156 21.6688 5.91762 21.7028L0.984164 22.8655C0.922445 22.8806 0.86053 22.8868 0.799787 22.8868ZM2.68887 17.5579L1.87499 21.0116L5.32894 20.1977L19.8762 5.65051C20.0277 5.49895 20.1109 5.29855 20.1109 5.08508C20.1109 4.87179 20.0277 4.67023 19.8762 4.51983L18.3679 3.01044C18.066 2.70849 17.5381 2.70849 17.2373 3.01044L2.68887 17.5579ZM5.73304 20.9243H5.74379H5.73304Z",
    fill: "#95A3B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2148 10.2426C17.0102 10.2426 16.8053 10.1646 16.6496 10.0078L12.8777 6.23607C12.5652 5.92356 12.5652 5.41692 12.8777 5.10441C13.1904 4.79171 13.697 4.79171 14.0095 5.10441L17.7813 8.87613C18.0938 9.18864 18.0938 9.69528 17.7813 10.0078C17.6244 10.1646 17.4197 10.2426 17.2148 10.2426Z",
    fill: "#95A3B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_7533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b5820ab0ec3d6a631979abdd4a3f114c.svg";
export { ForwardRef as ReactComponent };